export default __webpack_public_path__ + "static/media/PAN.d8adcfdf.svg";